export default __webpack_public_path__ + "static/media/img_logo.4dd8f2f7.svg";